<template>
  <div class="agreement-list flex flex-fc" style="height: 100vh">
    <div class="business-info" v-if="!contractId">
      <div class="business-name">{{ traderName }}</div>
      <div class="business-type">
        <div v-if="type" :class="['tag', changeTypeValue == '1' ? 'active' : '']" @click="changeTypeValue = '1'">
          签约人管理
        </div>
        
        <div :class="['tag', changeTypeValue == '2' ? 'active' : '']" @click="changeTypeValue = '2'">
          合同管理
        </div>
      </div>
    </div>
    <div class="agreement-top" v-if="!contractId">
      <div class="choice" v-if="changeTypeValue == '2'">
        <van-dropdown-menu>
          <van-dropdown-item :title="queryParams.plazaId ? '' : '广场'" v-model="queryParams.plazaId"
            :options="dropdown.plazaList" @change="(value) => dropdownChange('plazaId', value)" />
          <van-dropdown-item :title="queryParams.brandId ? '' : '品牌'" :disabled="!queryParams.plazaId"
            v-model="queryParams.brandId" :options="dropdown.brandList"
            @change="(value) => dropdownChange('brandId', value)" />
          <van-dropdown-item :title="queryParams.contractType ? '' : '合同类型'" v-model="queryParams.contractType"
            :options="dropdown.contractTypes" @change="(value) => dropdownChange('contractType', value)" />
          <van-dropdown-item :title="queryParams.contractState ? '' : '合同状态'" v-model="queryParams.contractState"
            :options="dropdown.contractState" @change="(value) => dropdownChange('contractState', value)" />
        </van-dropdown-menu>
      </div>
    </div>

    <div class="business-list" v-if="changeTypeValue == '1'">
      <template v-if="traderId">
        <div class="business-item" v-for="(item, index) in sealList" :key="index">
          <div class="business-name">
            <div class="name-left">
              <span class="user-name">{{ item.name }}</span>
              <span :class="['name-type', item.type == 1 ? 'master' : 'user']">{{ item.type == 1 ? '印章管理员' : '印章保管员'
              }}</span>
            </div>

            <div class="name-edit" v-if="item.type == 2 && sealList.length > 1" @click="changeKeeper(item)">
              <van-icon name="edit" />
              <span>更换保管员</span>
            </div>
          </div>

          <div class="phone">{{ item.mobile }}</div>
          <div class="card">{{ item.idNo }}</div>
          <div class="info" v-if="item.type == 1">
            如需变更印章管理员请联系万达商管
          </div>
        </div>
      </template>

      <template v-else>
        <span style="font-size: 18px">无</span>
      </template>
    </div>

    <div class="list flex-1" id="list" v-if="changeTypeValue == '2'">
      <van-pull-refresh v-model="onRefreshLoading" @refresh="onRefresh">
        <template v-if="list.length > 0">
          <div class="list-item flex flex-col" v-for="(item, index) in list" :key="index">
            <div class="item-info flex-1 flex flex-col flex-jsa">
              <div class="row-title flex flex-jsb flex-ac">
                <div class="row-name">合同编码：{{ item.contractCode }}</div>
                <div class="row-status status1">
                  <!-- {{item.contractState}} -->
                  {{ item.contractState | getStateName }}
                </div>
              </div>
              <div class="text-c flex">
                <div class="contract-type">{{ item.contractType }}</div>
              </div>

              <div class="row-address flex flex-ac">
                <img src="@/assets/img/dq/icon/listitem_1.png" />
                <div>
                  {{ item.plazaName }} - {{ item.brandName }} -
                  {{ item.bunkDesc }}
                </div>
              </div>
              <div class="row-time flex flex-ac">
                <img src="@/assets/img/dq/icon/listitem_2.png" />
                <div>{{ item.startTime }} 至 {{ item.endTime }}</div>
              </div>
            </div>
            <div class="item-action flex flex-end">
              <van-button v-show="item.contractUrl" round color="#FF6F00" plain
                @click="downLoad(item.contractUrl)">下载合同</van-button>
              <template v-if="item.contractState == 1">
                <van-button round color="#FF6F00" @click="sign(item)">
                  签署合同
                </van-button>
              </template>
            </div>
          </div>

          <van-divider v-if="!contractId" contentPosition="center"
            customStyle="color: #1989fa; border-color: #1989fa; font-size: 18px;">{{
              list.length == queryParams.totalCount
              ? '没有更多了'
              : '加载更多...'
            }}</van-divider>
        </template>

        <div class="null" v-if="list.length == 0">
          <img :src="require('@/assets/img/dq/null.png')" />
          <span>暂无合同</span>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { Dialog } from 'vant';
import {
  apiGetAgreementList,
  apiGetPlaza,
  ApiGetBrand,
  apiGetContractFile,
  ApiGetSealUser,
  ApiGetViewsSeal,
  ApiGetViewsPlazaSeal,
  ApiGetViewsBrandSeal,
  ApiGetCompanySignUrl,
} from '@/api/dq';
import moment from 'moment';
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};

// 合同状态
// 合同状态：1.未签署 2.万达未签署 3.已签署 4.已撤销 5.已作废 6.已过期
const contractState = [
  { text: '全部', value: '' },
  { text: '未签署', value: 1 },
  { text: '万达未签署', value: 2 },
  { text: '已签署', value: 3 },
  { text: '已撤销', value: 4 },
  { text: '已作废', value: 5 },
  { text: '已过期', value: 6 },
];
// 宣传推广合同
// 物业合同
// 租赁及物业合同
// 租赁合同
// 多经合同

// 合同类型
const contractTypes = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '宣传推广合同',
    value: '宣传推广合同',
  },
  {
    text: '物业合同',
    value: '物业合同',
  },
  {
    text: '租赁及物业合同',
    value: '租赁及物业合同',
  },
  {
    text: '租赁合同',
    value: '租赁合同',
  },
  {
    text: '多经合同',
    value: '多经合同',
  },
];
export default {
  data() {
    return {
      contractId: '',
      list: [],
      queryParams: {
        plazaId: '',
        brandId: '',
        contractType: '',
        contractState: '',
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      },
      dropdown: {
        plazaName: '',
        brandName: '',
        contractTypeName: '',
        contractStateName: '',
        plazaList: [],
        brandList: [],
        contractState,
        contractTypes,
      },
      onRefreshLoading: false,
      isLoadingAll: false,
      timer: 0,

      changeTypeValue: '2',
      traderId: '',
      traderName: '',
      type: null,
      sealList: [],
      roleTypeSign: false
    };
  },
  filters: {
    getStateName(value) {
      let item = contractState.find((v) => v.value == value);
      return item.text;
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.base.userInfo;
    },
    userId() {
      return this.$store.state.account.userId;
    },
  },


  methods: {
    GetSealUser() {
      let data = {
        traderId: this.traderId,
      };
      if (this.type == 2) {
        data.type = 2;
      }
      ApiGetSealUser(data).then((res) => {
        this.sealList = res;
        this.roleTypeSign = res.find(v => v.type == 2 && v.userId == this.userId) ? true : false
      });
    },
    changeKeeper(item) {
      this.$router.push({
        name: 'change_user',
        query: item,
      });
    },

    onRefresh() {
      // return;
      this.onRefreshLoading = true;
      this.queryParams.pageNum = 1;
      this.list = [];
      this.getList();
    },
    async getList() {
      // 个体用户
      if (!this.traderId) {
        let data = {
          ...this.queryParams,
          userId: this.userId,
          contractId: this.contractId,
        };

        for (const key in data) {
          if (!data[key]) {
            delete data[key];
          }
        }

        let res = await apiGetAgreementList(data);
        this.onRefreshLoading = false;
        let list = data.contractId ? res : res.items;

        if (!data.contractId) {
          this.queryParams.totalCount = res.totalCount;
          this.list = this.list.concat(res.items);
        } else {
          this.list = list;
        }
      } else {
        // 企业用户
        let data = {
          ...this.queryParams,
          traderId: this.traderId,
          contractId: this.contractId,
        };

        for (const key in data) {
          if (!data[key]) {
            delete data[key];
          }
        }

        let res = await ApiGetViewsSeal(data);
        this.onRefreshLoading = false;
        let list = data.contractId ? res : res.items;

        if (!data.contractId) {
          this.queryParams.totalCount = res.totalCount;
          this.list = this.list.concat(res.items);
        } else {
          this.list = list;
        }
      }
    },
    async getPlazaList() {
      let res = null;
      // 个体用户
      if (!this.traderId) {
        let data = {
          userId: this.userId,
        };
        res = await apiGetPlaza(data);
      } else {
        // 企业用户
        let data = {
          traderId: this.traderId,
        };
        res = await ApiGetViewsPlazaSeal(data);
      }

      let plazaList = res.map((el) => ({
        text: el.plazaName,
        value: el.plazaId,
      }));
      plazaList.unshift({ text: '全部', value: '' });
      this.dropdown.plazaList = plazaList;
    },
    async getBrandList() {
      let res = null;
      // 个体用户
      if (!this.traderId) {
        let data = {
          plazaId: this.queryParams.plazaId,
          userId: this.userId,
        };
        res = await ApiGetBrand(data);
      } else {
        // 企业用户
        let data = {
          plazaId: this.queryParams.plazaId,
          traderId: this.traderId,
        };
        res = await ApiGetViewsBrandSeal(data);
      }

      let brandList = res.map((el) => ({
        text: el.brandName,
        value: el.brandId,
      }));
      brandList.unshift({
        text: '全部',
        value: '',
      });
      this.dropdown.brandList = brandList;
    },
    dropdownChange(type, value) {
      this.queryParams[type] = value;
      this.list = [];
      this.queryParams.pageNum = 1;
      if (type === 'plazaId') {
        this.queryParams.plazaId = value;
        this.queryParams.brandId = '';
        this.getBrandList();
      }
      this.getList();
    },
    formatDate(time) {
      return moment(time).format('YYYY-MM-Do');
    },
    downLoad(contractUrl) {
      if (contractUrl) {
        let index = contractUrl.indexOf('/ZCZL');
        let key = contractUrl.substring(index);
        apiGetContractFile(key)
          .then((res) => {
            let href = res.data;
            if (isWechat()) {
              this.$router.push({
                path: '/dq/guide',
                query: {
                  path: href,
                },
              });
            } else {
              this.$router.push({
                path: '/dq/guide_phone',
                query: {
                  path: href,
                },
              });
            }
          })
          .catch();
      }
    },
    async sign(item) {
      // let href = '';
      // if (this.traderId) {
      //   let data = {
      //     contractId: item.contractId,
      //     traderId: this.traderId,
      //   };
      //   href = await ApiGetCompanySignUrl(data);
      // } else {
      //   href = item.signUrl;
      // }
      let href = await ApiGetCompanySignUrl({contractId: item.contractId});

      Dialog.confirm({
        title: '合同签署',
        message: '您是否现在跳转到万达电签平台进行合同电签?',
      }).then(() => {
        if (isWechat()) {
          this.$router.push({
            path: '/dq/guide',
            query: {
              path: href,
            },
          });
        } else {
          this.$router.push({
            path: '/dq/guide_phone',
            query: {
              path: href,
            },
          });
        }
      });
    },
  },
  async mounted() {
    this.contractId = this.$route.query.eventId;
    this.traderId = this.$route.query.traderId;
    this.traderName = this.$route.query.traderName;
    this.type = this.$route.query.roleType || this.$route.query.type;

    if (!this.type || this.type.includes(2)) {
      this.roleTypeSign = true
    } else {
      this.roleTypeSign = false
    }

    if (this.traderId) {
      this.GetSealUser();
    }

    this.getPlazaList();

    this.getList();

    setTimeout(() => {
      let list = document.getElementById('list');
      if (list) {
        list.addEventListener(
          'scroll',
          this.$bsUtils.bsDebounce((e) => {
            let distance =
              e.target.scrollHeight -
              e.target.scrollTop -
              e.target.clientHeight;

            if (distance < 60) {
              if (this.list.length < this.queryParams.totalCount) {
                this.queryParams.pageNum++;
                this.getList();
              }
            }
          }, 300)
        );
      }
    }, 300);
  },
};
</script>

<style lang="less" scoped>
@import url('./dq.global.less');

.agreement-list {
  text-align: left;
  line-height: 1;
  background: #f3f5f6;
  font-family: PingFangSC-Medium, PingFang SC;

  .agreement-top {
    background: #fff;

    // height: 180px;
    .user-info {
      display: flow-root;
      position: relative;
      width: 100%;
      height: 125px;

      .img1 {
        position: absolute;
        width: 100%;
        z-index: 1;
      }

      .img3 {
        width: 65px;
        height: 60px;
        position: absolute;
        bottom: 22px;
        right: 24px;
        z-index: 2;
      }

      .user-name {
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        position: relative;
        z-index: 3;
        margin: 25px 0 0 8px;

        .name {
          margin-left: 10px;
        }

        .img2 {
          width: 62px;
          height: 20px;
        }

        .user-type {
          position: absolute;
          z-index: 4;
          font-size: 12px;
          font-weight: 500;
          color: #ffffff;
          left: 4px;
        }
      }

      .user {
        // width: 100%;
        // box-sizing: border-box;
        padding: 4px 24px;
        font-size: 12px;
        font-weight: 500;
        color: #111111;
        position: relative;
        z-index: 5;

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }

        .user-th {
          margin-top: 8px;
        }
      }
    }

    .choice {
      padding: 0 16px;

      /deep/.van-dropdown-menu__bar {
        box-shadow: 0 0px 0px #fff;
        justify-content: space-between;

        .van-dropdown-menu__item {
          -webkit-box-flex: none;
          -webkit-flex: none;
          flex: none;
          width: 25%;
        }
      }
    }
  }

  .list {
    padding: 0 12px;
    overflow: auto;

    .list-item {
      margin-top: 14px;
      padding: 14px;
      height: 158px;
      background: #ffffff;
      border-radius: 8px;

      .item-info {
        font-size: 12px;

        img {
          margin-right: 4px;
        }

        .row-title {
          .row-name {
            font-size: 16px;
            font-weight: 500;
            color: #111111;
          }

          .row-status {
            padding: 1px 2px;
            font-size: 13px;
            font-weight: 400;
            border-radius: 2px;
          }

          .status1 {
            background: #fff1ef;
            color: #FF6F00;
          }

          .status2 {
            background: #fdf6e9;
            color: #ff871d;
          }

          .status3 {
            background: #e9f8fd;
            color: #65b2f6;
          }

          .status4 {
            background: #65b2f6;
            color: #999999;
          }
        }

        .contract-type {
          border-radius: 2px;
          padding: 2px 4px;
          color: #999999;
          border: 1px solid #e7e7e7;
        }

        .row-address {
          line-height: 16px;
        }
      }

      .item-action {
        text-align: right;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;

        .van-button {
          width: 96px;
          height: 32px;
          margin-left: 12px;
        }
      }
    }
  }

  .null {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;

    img {
      width: 249px;
      height: 196px;
      margin: 60px 0 30px;
    }
  }

  .van-pull-refresh {
    min-height: 100%;
  }
}

.business-info {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  display: flex;
  padding: 12px 20px;
  background: #fff;
  align-items: center;

  .business-name {
    flex: 8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 2;
  }

  .business-type {
    // flex: 10;
    font-size: 14px;
    display: flex;
    justify-content: space-around;
    background: #f3f5f6;
    border-radius: 15px;
    padding: 2px 8px;

    .tag {
      padding: 6px 12px;
    }

    .active {
      font-weight: 500;
      color: #FF6F00;
      background: #ffffff;
      border-radius: 17px;
      transition: all 0.2s easy;
    }
  }
}

.business-list {
  padding: 12px;

  .business-item {
    background: #fff;
    padding: 16px 12px;
    border-radius: 8px;
    margin-bottom: 16px;

    .business-name {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .name-left {
        display: flex;
        align-items: center;

        .user-name {
          font-size: 16px;
          font-weight: 500;
          color: #111111;
        }

        .name-type {
          margin-left: 12px;
          padding: 2px 4px;
          border-radius: 2px;
          font-size: 13px;
          font-weight: 400;
        }

        .master {
          background: #e9f8fd;
          color: #65b2f6;
        }

        .user {
          background: #fdf6e9;
          color: #fc9128;
        }
      }

      .name-edit {
        font-size: 13px;
        font-weight: 400;
        color: #fc9128;
        display: flex;
        align-items: center;
      }
    }

    .phone {
      margin-top: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
    }

    .card {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }

    .info {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }
  }
}
</style>